import React, { Fragment, useContext, useEffect, useState } from 'react';
import { Button, Card, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import { useContextInfo } from '../../context/ContextInfo';
import { fetchConToken } from '../../api/fetch';
import { classHost } from '../../data/host';
import Select from 'react-select';

import { RedContext } from '../../context/connection/ContextRed';
import { useForm } from '../../hooks/useForm';
const initialState = {
    id: '',
    nodo: '',
    nombre: '',
    red: '',
    cidr: '24',
    tipo: '0',
    vlan: '',
};
const ModIpv4 = ({ show, onClose, ipv4, callBk }) => {
    const { setResp } = useContextInfo();
    const { redState } = useContext(RedContext);
    const [selectedOption, setSelectedOption] = useState([]); // Estado para almacenar la opción seleccionada

    const [load, setLoad] = useState(false);
    const [validated, setValidated] = useState(false);
    const [values, handleInputChange, reset, setFormValue] = useForm({ ...initialState });
    const { id } = values;
    useEffect(() => {
        !show ? setFormValue({ ...initialState }) : setFormValue({ ...values, ...ipv4 });
        !show ? setSelectedOption([]) : setSelectedOption(ipv4.olts ? JSON.parse(ipv4?.olts) : []);
    }, [show]);

    const funClose = () => {
        if (id) {
            onClose();
        } else {
            reset();
            onClose();
        }
    };

    const handleSelChange = (selectedOption) => {
        setSelectedOption(selectedOption); // Actualiza el estado con la opción seleccionada
    };
    const onSubmit = async (e) => {
        const form = e.currentTarget;
        e.preventDefault();
        setLoad(true);
        if (form.checkValidity() === false) {
            setValidated(true);
        } else {
            let res;
            let data = { ...values, olts: selectedOption };

            if (id.length !== 0) {
                res = await fetchConToken(`networks/ipv4/${id}`, data, 'PUT');
            } else {
                res = await fetchConToken('networks/ipv4', data, 'POST');
            }
            setResp(res);
            callBk();
            reset();
            onClose();
        }
        setLoad(false);
    };

    const oltOptions = redState.olts.map((mk) => ({
        value: mk.id,
        label: mk.nombre,
    }));
    return (
        <Modal show={show} onHide={funClose}>
            <Modal.Header onHide={funClose} closeButton>
                <h4 className="modal-title">{id ? 'Editar Ipv4' : 'Nueva red Ipv4'}</h4>
            </Modal.Header>
            <Modal.Body>
                <>
                    <Row>
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Form noValidate validated={validated} onSubmit={onSubmit}>
                                        {' '}
                                        <Form.Group className="mb-3" controlId="validationCustom999">
                                            <Form.Label>Nombre de red</Form.Label>
                                            <Form.Control
                                                required
                                                type="text"
                                                value={values.nombre}
                                                name="nombre"
                                                onChange={handleInputChange}
                                            />
                                            <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                        </Form.Group>{' '}
                                        <Form.Group className="mb-3" controlId="validationCustom022">
                                            <Form.Label>Router</Form.Label>
                                            <Form.Select
                                                value={values.nodo}
                                                name="nodo"
                                                required
                                                onChange={handleInputChange}>
                                                <option value={''} disabled selected>
                                                    Seleccionar...
                                                </option>
                                                {redState.mktiks.map((mk, i) => (
                                                    <option value={mk.id} key={i}>
                                                        {mk.nodo}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                        <Row>
                                            <Form.Group className="mb-3" controlId="validationCusolts">
                                                <Form.Label>Olts</Form.Label>
                                                <Select
                                                    isMulti={true}
                                                    value={selectedOption} // Estado que contiene las opciones seleccionadas
                                                    onChange={handleSelChange} // Manejador de cambio
                                                    options={oltOptions} // Opciones generadas dinámicamente
                                                    className="react-select"
                                                    classNamePrefix="react-select"
                                                />
                                            </Form.Group>
                                        </Row>
                                        <Row>
                                            <Col xs={8} md={8}>
                                                {' '}
                                                <Form.Group className="mb-3" controlId="validationCusto">
                                                    <Form.Label>Red</Form.Label>
                                                    <Form.Control
                                                        required
                                                        type="text"
                                                        // disabled={used === 0 ? false : true}
                                                        value={values.red}
                                                        name="red"
                                                        onChange={handleInputChange}
                                                    />
                                                    <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                                </Form.Group>{' '}
                                            </Col>
                                            <Col>
                                                {' '}
                                                <Form.Group className="mb-3" controlId="validationCusto">
                                                    <Form.Label>Vlan</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={values.vlan}
                                                        name="vlan"
                                                        onChange={handleInputChange}
                                                    />
                                                    <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                                </Form.Group>{' '}
                                            </Col>
                                        </Row>
                                        <Form.Group className="mb-3" controlId="validationCustom0333">
                                            <Form.Label>CIDR</Form.Label>
                                            <Form.Select
                                                value={values.cidr}
                                                name="cidr"
                                                // disabled={used === 0 ? false : true}
                                                required
                                                onChange={handleInputChange}>
                                                {classHost.map((c) => (
                                                    <Fragment key={c.clase}>
                                                        <option disabled={true} className=" text-center text-lg">
                                                            {c.clase}
                                                        </option>
                                                        {c.redes.map((h, i) => (
                                                            <option value={h.cidr} key={i * 2} className="my-2">
                                                                {h.cidr}
                                                                {` (${h.mask} - ${h.host} hosts, ${
                                                                    parseInt(h.host) + 2
                                                                } IP)`}
                                                            </option>
                                                        ))}
                                                    </Fragment>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                        {load ? (
                                            <Button color="primary" disabled>
                                                <Spinner className="spinner-border-sm me-1" tag="span" color="white" />
                                                Guardando...
                                            </Button>
                                        ) : (
                                            <Button type="submit">Guardar</Button>
                                        )}
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </>
            </Modal.Body>
        </Modal>
    );
};

export default ModIpv4;
